import React, { useEffect, useRef, useState } from 'react';


// Assets
// import imgProduct from "../assets/images/img7.jpg"; 

const MiddleSection = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // Update state based on visibility
        // If visible = true (Play Animation)
        // If hidden = false (Reset Animation)
        setIsVisible(entry.isIntersecting);
      },
      { 
        threshold: 0.2 // Trigger when 20% of the section is visible
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.disconnect();
      }
    };
  }, []);

  return (
    <section 
      className={`graph-section ${isVisible ? 'in-view' : ''}`} 
      ref={sectionRef}
    >
      <div className="container position-relative h-100">
        
        {/* --- Header --- */ }
        <div className="text-center mb-5 position-relative z-2 header-content">
            {/* <span className="graph-subtitle">Clinical Formulation</span> */}
            <h2 className="graph-title">मजबूत शरीर, स्वस्थ जीवन <span>मोरिंगा के साथ”</span></h2>
        </div>

        {/* --- The Graph Container --- */}
        <div className="graph-container">
          
          {/* 1. Center Hub (The Product) */}
          <div className="center-hub">
            <div className="pulse-circle"></div>
            <div className="pulse-circle delay-1"></div>
            
            <div className="product-wrapper">
                <img src="../../../images/centerprdct.png" alt="Moringa Bottle" />
                {/* The Scanner Line Animation */}
                {/* <div className="scanner-line"></div> */}
            </div>
          </div>

          {/* 2. The Satellites (Ingredient Cards) */}
          
          {/* Top Left */}
          <div className="satellite sat-tl">
            <div className="connector-line line-tl"></div>
            <div className="info-card">
                <div className="icon-box">1.</div>
                <div className="text-content">
                    <h4> एंटीऑक्सीडेंट शक्ति </h4>
                    <p>Free radicals से बचाव और शरीर को detox करता है</p>
                </div>
            </div>
          </div>

          {/* Top Right */}
          <div className="satellite sat-tr">
            <div className="connector-line line-tr"></div>
            <div className="info-card">
                <div className="icon-box">2.</div>
                <div className="text-content">
                    <h4> इम्यूनिटी बूस्टर</h4>
                    <p>रोग प्रतिरोधक क्षमता को मजबूत बनाता है</p>
                </div>
            </div>
          </div>

          {/* Bottom Left */}
          <div className="satellite sat-bl">
            <div className="connector-line line-bl"></div>
            <div className="info-card">
                <div className="icon-box">3.</div>
                <div className="text-content">
                    <h4>पोषण से भरपूर</h4>
                    <p>विटामिन, मिनरल्स और प्रोटीन का खजाना</p>
                </div>
            </div>
          </div>

          {/* Bottom Right */}
          <div className="satellite sat-br">
            <div className="connector-line line-br"></div>
            <div className="info-card">
                <div className="icon-box">4</div>
                <div className="text-content">
                    <h4> प्राकृतिक ऊर्जा</h4>
                    <p>दिनभर की थकान दूर कर ऊर्जा बढ़ाता है</p>
                </div>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
};

export default MiddleSection;